/*!
 * HaiKom CodeMirror Extensions Library.
 *
 * Copyright (C) HaiKom AB 2007-2014
 */
;(function($, cm) {
	'use strict';

	if (!cm) {
		console.error('CodeMirror is not defined and/or is not available');
	}
	/**
	 * Converts a normal HTML textarea element to a CodeMirror editor but without the default submit wrapper which can cause JavaScript errors.
	 */
	cm.convertTextArea = function (textarea, options) {
		if(!textarea) {
			console.error('No text area is defined');
			return;
		}

		var $textarea = $(textarea);

		var tagName = $textarea.prop('tagName').toLowerCase();
		if(tagName !== 'textarea') {
			console.warn('This function does not support elements of type ' + tagName + '.');
			return;
		}

		var cmi = $textarea.data('CodeMirrorInstance');

		if(cmi) {
			return cmi;
		}

		var $backingTextArea = $textarea;
		var save = function () {
			var value = editor.getValue();
			$backingTextArea.val(value);
		};

		options = options || {};
		options.value = $backingTextArea.val();

		if (!options.autofocus &&
			$backingTextArea.attr('autofocus') !== null) {
			options.autofocus = true;
		}
		if (!options.tabindex &&
			$backingTextArea.attr('tabindex') !== null) {
			options.tabindex = $backingTextArea.attr('tabindex');
		}

		$backingTextArea.css('display', 'none');

		var editor = CodeMirror(function (node) {
			$backingTextArea.wrap('<div class="cm-wrapper" />')
											.after($(node));
		}, options);
		editor.save = save;
		editor.getTextArea = function () {
			return $backingTextArea.get(0);
		};
		editor.toTextArea = function () {
			save();
			$(editor.getWrapperElement()).remove();
			$backingTextArea.css('display', '')
											.unwrap();
		};
		editor.on('change', save);

		$textarea.data('CodeMirrorInstance', editor);

		return editor;
	};
})(jQuery, CodeMirror);
